import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap"
import "bootstrap/dist/js/bootstrap.min.js";
import './assets/scss/app.scss'
import "vue-multiselect/dist/vue-multiselect.css"
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css'; 
import '../node_modules/bootstrap-icons/font/bootstrap-icons.scss'
import "dropzone-vue/dist/dropzone-vue.common.css";
import 'sweetalert2/dist/sweetalert2.min.css';
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import 'vue3-timeline/dist/style.css'
import 'vue3-tour/dist/vue3-tour.css'
import 'vue3-easy-data-table/dist/style.css';
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue-rate/dist/vue-rate.css'

import VueFeather from "vue-feather";
import VueKnob from 'knob'
import Multiselect from 'vue-multiselect'
import { quillEditor } from "vue3-quill";
import SimpleTypeahead from 'vue3-simple-typeahead';
import breadCrumbs from './layout/breadCrumbs.vue'
import VueApexCharts from "vue3-apexcharts";
import Slick from 'vue-slick'
import VueNumber from "vue-number-animation";  
import settingPage from "./layout/customizer/settingPage.vue" 
import DropZone from "dropzone-vue";
import VueKanban from 'vue-kanban'
import VuePictureSwipe from 'vue3-picture-swipe';
import VueSweetalert2 from 'vue-sweetalert2';
import Popper from "vue3-popper";
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import Toaster from "@meforma/vue-toaster";
import vue3StarRatings from "vue3-star-ratings";
import { plugin } from 'vue3-timeline'
import Sparkline from 'vue-sparklines'
import Lightbox from 'vue-easy-lightbox'
import { VueMasonryPlugin } from 'vue-masonry';
import vueChartist from "vue-chartist"
import Vue3Tour from 'vue3-tour'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import VueAnimateOnScroll from 'vue3-animate-onscroll';
import AosVue from "aos-vue";
import rate from 'vue-rate'
import Datepicker from '@vuepic/vue-datepicker';

import { createI18n } from 'vue-i18n'
import English from "./locales/en.json"
import Español from "./locales/es.json"
import Deutsch from "./locales/de.json"
import Français from "./locales/fr.json"
import Português from "./locales/pt.json"
import 简体中文 from "./locales/cn.json"
import لعربية from "./locales/ae.json"
import German from "./locales/ge.json"
import Russian from "./locales/ru.json"
import Arabic from "./locales/ar.json"
const i18n = createI18n({ legacy: false, // you must specify 'legacy: false' option
  locale: '',
  messages: {
   English: English,
    Español: Español,
    Deutsch: Deutsch,
    Français: Français,   
   Português: Português,
    简体中文: 简体中文,
    لعربية: لعربية,
    German: German,
    Russian: Russian,
    Arabic: Arabic
    }
  })

createApp(App)
.use(router)
.use(VueSweetalert2)
.use(VueKanban)
.use(store).use(DropZone)
.use(VueNumber)
.use(PerfectScrollbar)
.use(SimpleTypeahead)
.use(AosVue)
.use(Toaster)
.use(rate)
.use(i18n)
.use(Vue3Tour)
.use(Lightbox)
.use(VueAnimateOnScroll)
.use(plugin)
.use(Sparkline)
.use(vueChartist)
.use(VueMasonryPlugin)
.use(quillEditor)
.component('EasyDataTable', Vue3EasyDataTable)
.component("Popper", Popper)
.component('vue-picture-swipe', VuePictureSwipe)
.component('Datepicker', Datepicker)
.component("settingPage", settingPage)
.component("VueKnob",VueKnob)
.component("Slick", Slick)
.component("apexchart", VueApexCharts)
.component('breadCrumbs', breadCrumbs)
.component(VueFeather.name, VueFeather)
.component("vue3-star-ratings", vue3StarRatings)
.component('multiselect', Multiselect)
.mount('#app');

  